import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  Skeleton,
  Button,
  List
} from "antd";
import { FilePdfOutlined, FileTextOutlined } from "@ant-design/icons";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Get } from "../../../config/api/get";
import { ASSOCIATE_PORTAL, UPLOADS_URL } from "../../../config/constants/api";
import AssociateLayout from "../../../components/AssociateLayout";
import VideoPlayer from "../../../components/VideoPlayer2";
import "../../upcoming-lessons/upcoming-lessons.css";

function AssociateLectureDetails() {
  const { lectureId } = useParams();
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = useState(true);
  const [lecture, setLecture] = useState(null);

  useEffect(() => {
    loadLecture();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lectureId]);

  const loadLecture = async () => {
    setLoading(true);
    try {
      const res = await Get(ASSOCIATE_PORTAL.lecture + lectureId, token);
      if (res?.status) {
        setLecture(res.data?.lecture);
      }
    } finally {
      setLoading(false);
    }
  };

  const courseId = lecture?.course?._id || lecture?.course;

  return (
    <AssociateLayout>
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "32px 24px" }}>
        <Button
          type="link"
          icon={<FaArrowLeft />}
          onClick={() =>
            courseId
              ? navigate(`/associate/courses/${courseId}`)
              : navigate("/associate/dashboard")
          }
          style={{ paddingLeft: 0, marginBottom: 16 }}
        >
          Back to course
        </Button>

        {loading ? (
          <Skeleton active />
        ) : lecture ? (
          <Card bordered={false}>
            <Typography.Title level={2} style={{ marginTop: 0 }}>
              {lecture.lectureNo ? `${lecture.lectureNo}. ` : ""}
              {lecture.title}
            </Typography.Title>
            {lecture.description ? (
              <Typography.Paragraph>{lecture.description}</Typography.Paragraph>
            ) : null}

            {lecture?.fileUrls?.length > 0 ? (
              <div style={{ marginTop: 24 }}>
                <Typography.Title level={4}>Videos</Typography.Title>
                {lecture.fileUrls.map((_, index) => (
                  <div key={`${lecture._id}-video-${index}`} style={{ marginBottom: 24 }}>
                    {lecture.fileUrls.length > 1 ? (
                      <Typography.Text type="secondary">
                        Video {index + 1}
                      </Typography.Text>
                    ) : null}
                    <VideoPlayer data={lecture} index={index} />
                  </div>
                ))}
              </div>
            ) : null}

            {lecture.files?.length > 0 ? (
              <div style={{ marginTop: 24 }}>
                <Typography.Title level={4}>Attachments</Typography.Title>
                <List
                  bordered
                  dataSource={lecture.files}
                  renderItem={(file, index) => {
                    const href = `${UPLOADS_URL}/${file}`;
                    const isPdf = file.toLowerCase().endsWith(".pdf");
                    return (
                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            isPdf ? (
                              <FilePdfOutlined style={{ fontSize: 24 }} />
                            ) : (
                              <FileTextOutlined style={{ fontSize: 24 }} />
                            )
                          }
                          title={`Attachment ${index + 1}`}
                          description={file}
                        />
                        <Button
                          type="primary"
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download
                        </Button>
                      </List.Item>
                    );
                  }}
                />
              </div>
            ) : null}
          </Card>
        ) : (
          <Typography.Text type="secondary">Lecture not found</Typography.Text>
        )}
      </div>
    </AssociateLayout>
  );
}

export default AssociateLectureDetails;
